import {bootstrapDetectBreakpoint} from './bootstrapDetectBreakpoint';

export default class Breadcrumb {

    el;
    breakpoint

    openBreadcrumb(event, element) {

        const breadcrumb = element.closest('.is-breadcrumb')

        if (this.breakpoint.index < 4 && !(breadcrumb.classList.contains('open'))) {
            breadcrumb.classList.add('open');
            event.preventDefault();
            event.stopPropagation();
        }

    }

    init() {

        this.el = document.querySelectorAll('.is-breadcrumb-item--first');

        this.breakpoint = bootstrapDetectBreakpoint();

        window.addEventListener('resize', () => {
            this.breakpoint = bootstrapDetectBreakpoint();
        })

        if (this.el.length > 0) {
            this.el.forEach((element) => {
                element.addEventListener('click', (event) => {
                    this.openBreadcrumb(event, element);
                })
            })
        }

    }

}
